import { Box, IconButton, Link } from '@material-ui/core';
import React, { memo, useCallback } from 'react';
import { SOCIAL_LINKS } from 'src/constants';
import { useStyles } from './styles';

export enum screenSize {
  Desktop,
  Mobile,
}
interface GlobalHeaderProps {
  size: screenSize;
}

const socialLinks = (classes) => {
  return {
    twitter: {
      url: SOCIAL_LINKS.twitter,
      icon: () => (
        <svg
          className={classes.twitterIcon}
          width="32"
          height="32"
          viewBox="0 0 2500 1400"
          fill="none"
          xmlns="https://www.w3.org/2000/svg"
        >
          <path
            d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
            fill="white"
          ></path>
        </svg>
      ),
    },
    linkedin: {
      url: SOCIAL_LINKS.linkedin,
      icon: () => (
        <svg
          className={classes.socialButtonIcon}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="https://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.7381 21.7176H20.8949V17.2624C20.8949 16.2 20.8733 14.8328 19.4133 14.8328C17.9309 14.8328 17.7045 15.9888 17.7045 17.184V21.7176H14.8613V12.556H17.5925V13.8048H17.6293C18.0109 13.0848 18.9389 12.3248 20.3253 12.3248C23.2061 12.3248 23.7389 14.2208 23.7389 16.6888V21.7176H23.7381Z"
            fill="white"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6504 11.3024C10.7352 11.3024 10 10.5616 10 9.6504C10 8.74 10.736 8 11.6504 8C12.5624 8 13.3016 8.74 13.3016 9.6504C13.3016 10.5616 12.5616 11.3024 11.6504 11.3024Z"
            fill="white"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0758 21.7176H10.2246V12.556H13.0758V21.7176Z"
            fill="white"
          ></path>
        </svg>
      ),
    },
    youtube: {
      url: SOCIAL_LINKS.youtube,
      icon: () => (
        <svg
          className={classes.socialButtonIcon}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="https://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.0575 10.3586C23.8178 10.561 24.4119 11.1277 24.6241 11.8529C24.8845 13.2236 25.0101 14.6145 24.9992 16.0075C25.009 17.3952 24.8835 18.7808 24.6241 20.1464C24.4119 20.8716 23.8178 21.4383 23.0575 21.6407C21.6395 22 16.0079 22 16.0079 22C16.0079 22 10.3599 22 8.95837 21.6407C8.19809 21.4383 7.60399 20.8716 7.3918 20.1464C7.12687 18.7813 6.99576 17.3957 7.00016 16.0075C6.99473 14.614 7.12585 13.2231 7.3918 11.8529C7.60399 11.1277 8.19809 10.561 8.95837 10.3586C10.3756 9.99285 16.0079 10 16.0079 10C16.0079 10 21.6545 10 23.0575 10.3586ZM14.2058 13.4296V18.5776L18.9055 16.0075L14.2058 13.4296Z"
            fill="white"
          ></path>
        </svg>
      ),
    },
    facebook: {
      url: SOCIAL_LINKS.facebook,
      icon: () => (
        <svg
          className={classes.socialButtonIcon}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="https://www.w3.org/2000/svg"
        >
          <path
            d="M13.84 24.6978L13.7271 17.4251H11.0703V14.2719H13.84V11.8687C13.84 9.1348 15.4685 7.62469 17.9601 7.62469C19.1536 7.62469 20.402 7.83774 20.402 7.83774V10.5222H19.0265C17.6714 10.5222 17.2488 11.363 17.2488 12.2257V14.2719H20.2741L19.7905 17.4251H17.3634L17.2488 24.6978H13.84Z"
            fill="white"
          ></path>
        </svg>
      ),
    },
    instagram: {
      url: SOCIAL_LINKS.instagram,
      icon: () => (
        <svg
          className={classes.socialButtonIcon}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="https://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 8C13.8267 8 13.5553 8.01 12.702 8.048C11.85 8.088 11.27 8.222 10.76 8.42C10.234 8.624 9.78733 8.898 9.34267 9.34267C8.898 9.78733 8.62333 10.2333 8.42 10.76C8.222 11.27 8.08733 11.85 8.048 12.702C8.008 13.5553 8 13.8267 8 16C8 18.1733 8.01 18.4447 8.048 19.298C8.088 20.1493 8.222 20.73 8.42 21.24C8.624 21.7653 8.898 22.2127 9.34267 22.6573C9.78733 23.1013 10.2333 23.3767 10.76 23.58C11.2707 23.7773 11.8507 23.9127 12.702 23.952C13.5553 23.992 13.8267 24 16 24C18.1733 24 18.4447 23.99 19.298 23.952C20.1493 23.912 20.73 23.7773 21.24 23.58C21.7653 23.376 22.2127 23.1013 22.6573 22.6573C23.1013 22.2127 23.3767 21.7673 23.58 21.24C23.7773 20.73 23.9127 20.1493 23.952 19.298C23.992 18.4447 24 18.1733 24 16C24 13.8267 23.99 13.5553 23.952 12.702C23.912 11.8507 23.7773 11.2693 23.58 10.76C23.376 10.234 23.1013 9.78733 22.6573 9.34267C22.2127 8.898 21.7673 8.62333 21.24 8.42C20.73 8.222 20.1493 8.08733 19.298 8.048C18.4447 8.008 18.1733 8 16 8ZM16 9.44C18.1353 9.44 18.39 9.45067 19.2333 9.48733C20.0133 9.524 20.4367 9.65333 20.718 9.764C21.0927 9.90867 21.358 10.082 21.6393 10.3613C21.9187 10.6413 22.092 10.9073 22.2367 11.282C22.346 11.5633 22.4767 11.9867 22.512 12.7667C22.55 13.6107 22.5587 13.864 22.5587 16C22.5587 18.136 22.5487 18.39 22.5093 19.2333C22.4687 20.0133 22.3387 20.4367 22.2287 20.718C22.0793 21.0927 21.9093 21.358 21.6293 21.6393C21.35 21.9187 21.08 22.092 20.7093 22.2367C20.4293 22.346 19.9993 22.4767 19.2193 22.512C18.37 22.55 18.12 22.5587 15.98 22.5587C13.8393 22.5587 13.5893 22.5487 12.7407 22.5093C11.96 22.4687 11.53 22.3387 11.25 22.2287C10.8707 22.0793 10.61 21.9093 10.3307 21.6293C10.05 21.35 9.87067 21.08 9.73067 20.7093C9.62067 20.4293 9.49133 19.9993 9.45067 19.2193L9.44906 19.1745C9.42029 18.3694 9.41 18.0816 9.41 15.99C9.41 13.9005 9.42026 13.6101 9.44895 12.7979L9.45067 12.7493C9.49133 11.9693 9.62067 11.54 9.73067 11.26C9.87067 10.88 10.05 10.62 10.3307 10.3393C10.61 10.06 10.8707 9.88 11.25 9.74067C11.53 9.63 11.9507 9.5 12.7307 9.46L12.7692 9.45864C13.5887 9.4297 13.8633 9.42 15.97 9.42L16 9.44ZM11.892 16C11.892 13.732 13.73 11.892 16 11.892C18.268 11.892 20.108 13.73 20.108 16C20.108 18.268 18.27 20.108 16 20.108C13.732 20.108 11.892 18.27 11.892 16ZM16 18.6667C14.5267 18.6667 13.3333 17.4733 13.3333 16C13.3333 14.5267 14.5267 13.3333 16 13.3333C17.4733 13.3333 18.6667 14.5267 18.6667 16C18.6667 17.4733 17.4733 18.6667 16 18.6667ZM20.2707 12.69C20.8 12.69 21.2307 12.26 21.2307 11.73C21.2307 11.2007 20.7993 10.77 20.2707 10.7707C19.7413 10.7707 19.3107 11.2007 19.3107 11.73C19.3107 12.2593 19.7407 12.69 20.2707 12.69Z"
            fill="white"
          ></path>
        </svg>
      ),
    },
  };
};

const GlobalHeader: React.FC<GlobalHeaderProps> = ({ size }) => {
  const classes = useStyles();

  const handleClick = useCallback((url: string) => {
    if (window) window.open(url, '_top');
  }, []);

  return (
    <Box
      className={
        size === screenSize.Desktop
          ? classes.globalHeaderDesktop
          : classes.globalHeaderMobile
      }
    >
      <Box></Box>
      <Box
        className={`${classes.globalHeaderItemsWrapper} ${
          size === screenSize.Mobile ? classes.flexDirCol : ''
        }`}
      >
        <Box
          className={`${classes.linksWrapper} ${
            size === screenSize.Mobile ? classes.margin16 : ''
          }`}
        >
          <Link color="inherit" href="https://www.cambridge.org/what-we-do">
            About
          </Link>
          <Link color="inherit" href="/contact-us">
            Contact us
          </Link>
        </Box>
        <Box className={classes.socialButtonsWrapper}>
          {Object.entries(socialLinks(classes)).map((socialLink) => (
            <IconButton
              key={socialLink[0]}
              onClick={() => handleClick(socialLink[1]['url'])}
              className={classes.socialButton}
              aria-label={socialLink[0]}
              data-testid="socialBtn"
            >
              {socialLink[1]['icon']()}
            </IconButton>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default memo(GlobalHeader);
